module.exports = __webpack_public_path__ + "acc13fd4f498c8d7483d752bcc3e611f.pdf";